import { render, staticRenderFns } from "./mbgg.vue?vue&type=template&id=1d541cb9&scoped=true&"
import script from "./mbgg.vue?vue&type=script&lang=js&"
export * from "./mbgg.vue?vue&type=script&lang=js&"
import style0 from "./mbgg.vue?vue&type=style&index=0&id=1d541cb9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d541cb9",
  null
  
)

export default component.exports